<template>
    <div>
      <accAuthList></accAuthList>
    </div>
</template>

<script>
  import accAuthList from "../signSettings/components/account/index.vue";
    export default {
        name: "myAuth",
      components: {accAuthList},
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// pages/tpl/myAuth.vue